const products = [
  {
    _id: '1',
    name: 'Airpods Wireless Bluetooth Headphones',
    image: '/images/airpods.jpg',
    description:
      'Bluetooth technology lets you connect it with compatible devices wirelessly High-quality AAC audio offers immersive listening experience Built-in microphone allows you to take calls while working',
    brand: 'Apple',
    category: 'Electronics',
    price: 89.99,
    countInStock: 10,
    rating: 4.5,
    numReviews: 12,
  },
  {
    _id: '2',
    name: 'iPhone 11 Pro 256GB Memory',
    image:'/images/phone.jpg',
    description:
      'Introducing the iPhone 11 Pro. A transformative triple-camera system that adds tons of capability without complexity. An unprecedented leap in battery life',
    brand: 'Apple',
    category: 'Electronics',
    price: 599.99,
    countInStock: 7,
    rating: 4.0,
    numReviews: 8,
  },
  {
    _id: '3',
    name: 'Cannon EOS 80D DSLR Camera',
    image: '/images/camera.jpg',
    description:
      'Characterized by versatile imaging specs, the Canon EOS 80D further clarifies itself using a pair of robust focusing systems and an intuitive design',
    brand: 'Cannon',
    category: 'Electronics',
    price: 929.99,
    countInStock: 5,
    rating: 3,
    numReviews: 12,
  },
  {
    _id: '4',
    name: 'Sony Playstation 4 Pro White Version',
    image: '/images/playstation.jpg',
    description:
      'The ultimate home entertainment center starts with PlayStation. Whether you are into gaming, HD movies, television, music',
    brand: 'Sony',
    category: 'Electronics',
    price: 399.99,
    countInStock: 11,
    rating: 5,
    numReviews: 12,
  },
  {
    _id: '5',
    name: 'Logitech G-Series Gaming Mouse',
    image: '/images/mouse.jpg',
    description:
      'Get a better handle on your games with this Logitech LIGHTSYNC gaming mouse. The six programmable buttons allow customization for a smooth playing experience',
    brand: 'Logitech',
    category: 'Electronics',
    price: 49.99,
    countInStock: 7,
    rating: 3.5,
    numReviews: 10,
  },
  {
    _id: '6',
    name: 'Amazon Echo Dot 3rd Generation',
    image: '/images/alexa.jpg',
    description:
      'Meet Echo Dot - Our most popular smart speaker with a fabric design. It is our most compact smart speaker that fits perfectly into small space',
    brand: 'Amazon',
    category: 'Electronics',
    price: 29.99,
    countInStock: 0,
    rating: 4,
    numReviews: 12,
  },
  {
    _id: '7',
    name: 'Sony Playstation 4 Pro White Version',
    image: '/images/playstation.jpg',
    description:
      'The ultimate home entertainment center starts with PlayStation. Whether you are into gaming, HD movies, television, music',
    brand: 'Sony',
    category: 'Gaming',
    price: 399.99,
    countInStock: 11,
    rating: 5,
    numReviews: 12,
  },
  {
    _id: '8',
    name: 'Playstation DualSense Wireless Controller',
    image: '/images/console.jpg',
    description:
      'Haptic feedback - Feel physically responsive feedback to your in-game actions with dual actuators which replace traditional rumble motors. In your hands, these dynamic vibrations can simulate the feeling of everything from environments to the recoil of different weapons.',
    brand: 'Sony',
    category: 'Gaming',
    price: 69.99,
    countInStock: 50,
    rating: 5,
    numReviews: 90,
  },
  {
    _id: '9',
    name: 'Microsoft Xbox Series S Console',
    image: '/images/xbox.jpg',
    description:
      'Xbox Series S, the smallest, sleekest Xbox ever. At 60% smaller than Xbox Series X, it delivers the speed and performance of a next-gen, all-digital console at an accessible price point',
    brand: 'Xbox',
    category: 'Gaming',
    price: 299.99,
    countInStock: 20,
    rating: 4,
    numReviews: 50,
  },
  {
    _id: '10',
    name: 'Logitech G-Series Gaming Mouse',
    image: '/images/mouse.jpg',
    description:
      'Get a better handle on your games with this Logitech LIGHT SYNC gaming mouse. The six programmable buttons allow customization for a smooth playing experience',
    brand: 'Logitech',
    category: 'Gaming',
    price: 49.99,
    countInStock: 7,
    rating: 3.5,
    numReviews: 10,
  },
  {
    _id: '11',
    name: 'PopSockets MagSafe Phone Grip',
    image: '/images/phone_case2.jpg',
    description:
      'Our phone grip compatible with MagSafe we call a "PopGrip" securely attaches to your MagSafe-compatible case for maximum grip and kickstand capabilities',
    brand: 'PopSockets',
    category: 'Phones',
    price: 26.99,
    countInStock: 9,
    rating: 4.5,
    numReviews: 52,
  },
  {
    _id: '12',
    name: 'iPhone 11 Pro 256GB Memory',
    image:'/images/phone.jpg',
    description:
      'Introducing the iPhone 11 Pro. A transformative triple-camera system that adds tons of capability without complexity. An unprecedented leap in battery life',
    brand: 'Apple',
    category: 'Phones',
    price: 599.99,
    countInStock: 7,
    rating: 4.0,
    numReviews: 8,
  },
  {
    _id: '13',
    name: 'Airpods Wireless Bluetooth Headphones',
    image: '/images/airpods.jpg',
    description:
      'Bluetooth technology lets you connect it with compatible devices wirelessly High-quality AAC audio offers immersive listening experience Built-in microphone allows you to take calls while working',
    brand: 'Apple',
    category: 'Phones',
    price: 89.99,
    countInStock: 10,
    rating: 4.5,
    numReviews: 12,
  },
  {
    _id: '14',
    name: 'Belkin Magnetic Car Vent Mount PRO with MagSafe',
    image: '/images/phone_belking.jpg',
    description:
      'The Belkin Magsafe Vent Mount Pro is compatible with the Apple iPhone 14, 13, and 12 Series, and certified MagSafe Cases,This MagSafe certified phone mount for car is made of high-quality materials, securely keeping your MagSafe compatible phone in place while driving',
    brand: 'MAGSAFE COMPATIBLE',
    category: 'Phones',
    price: 35.99,
    countInStock: 7,
    rating: 3.5,
    numReviews: 5,
  },
  {
    _id: '15',
    name: 'Headphones with Protective Carrying Case',
    image: '/images/headphone1.jpg',
    description:
      ' Beoplay H95 includes a robust hardcase to store your headphones in plush security as you travel and experience life to the fullest. Lined with matching textile on the inside, the headphones and accompanying accessories are safely preserved while not in use.',
    brand: 'Bang & Olufsen',
    category: 'Headphones',
    price: 120.99,
    countInStock: 10,
    rating: 4.5,
    numReviews: 20,
  },
  
]

export default products
